/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ObjectServices
 */
export interface ObjectServices {
  /**
   *
   * @type {number}
   * @memberof ObjectServices
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof ObjectServices
   */
  name?: string
  /**
   *
   * @type {number}
   * @memberof ObjectServices
   */
  price?: number | null
  /**
   *
   * @type {string}
   * @memberof ObjectServices
   */
  measureUnit?: string | null
  /**
   *
   * @type {string}
   * @memberof ObjectServices
   */
  slug?: string | null
}

/**
 * Check if a given object implements the ObjectServices interface.
 */
export function instanceOfObjectServices(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function ObjectServicesFromJSON(json: any): ObjectServices {
  return ObjectServicesFromJSONTyped(json, false)
}

export function ObjectServicesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ObjectServices {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    price: !exists(json, 'price') ? undefined : json['price'],
    measureUnit: !exists(json, 'measureUnit') ? undefined : json['measureUnit'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
  }
}

export function ObjectServicesToJSON(value?: ObjectServices | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    price: value.price,
    measureUnit: value.measureUnit,
    slug: value.slug,
  }
}
